import { CrmConnectorTypeEnum, CrmFieldTypeEnum } from './types';

export const crmFieldData = {
  [CrmFieldTypeEnum.USER_FIRSTNAME]: {
    label: 'user_firstname',
    isUserField: true,
    icon: 'text_fields',
    inputType: 'text',
  },
  [CrmFieldTypeEnum.USER_LASTNAME]: {
    label: 'user_lastname',
    isUserField: true,
    icon: 'text_fields',
    inputType: 'text',
  },
  [CrmFieldTypeEnum.USER_BIRTHDAY]: {
    label: 'user_birthday',
    isUserField: true,
    icon: 'date_range',
    inputType: 'date',
  },
  [CrmFieldTypeEnum.USER_ZIPCODE]: {
    label: 'user_zipcode',
    isUserField: true,
    icon: 'location_on',
    inputType: 'text',
  },
  [CrmFieldTypeEnum.SHORT_TEXT]: {
    label: 'shortText',
    isUserField: false,
    icon: 'text_fields',
    inputType: 'text',
  },
  [CrmFieldTypeEnum.NUMBER]: {
    label: 'number',
    isUserField: false,
    icon: 'looks_one',
    inputType: 'number',
  },
  [CrmFieldTypeEnum.DATE]: {
    label: 'date',
    isUserField: false,
    icon: 'date_range',
    inputType: 'date',
  },
  [CrmFieldTypeEnum.SELECT]: {
    label: 'select',
    isUserField: false,
    icon: 'ballot',
    inputType: 'select',
  },
  [CrmFieldTypeEnum.BOOL]: {
    label: 'bool',
    isUserField: false,
    icon: 'toggle_on',
    inputType: 'checkbox',
  },
  [CrmFieldTypeEnum.RATING]: {
    label: 'rating',
    isUserField: false,
    icon: 'star',
    inputType: 'number',
  },
};

export const CRM_CONNECTOR_LABELS: Record<CrmConnectorTypeEnum, string> = {
  [CrmConnectorTypeEnum.ZENCHEF]: 'Zenchef',
};

export const CONNECTOR_SOURCE_ICON = 'sync_alt';

export const RATING_MIN = 1;
export const RATING_MAX = 5;
